module.exports = __webpack_public_path__ + "img/activity_intro.4eac71cb.png";